import { REHYDRATE } from "redux-persist";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import createInstance from "../../api/axiosinstance";
import Toast from "../../utils/toast";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

const dishaApi = createInstance("DISHA");

// Check user type
export const checkUserType = createAsyncThunk(
  "auth/checkUserType",
  async (email, { rejectWithValue }) => {
    try {
      const response = await dishaApi.post(
        `/get_details_for_login?email=${encodeURIComponent(email)}`
      );
      console.log("resss", response);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        console.log(error),
        error.response?.data?.error || "Error checking user type"
      );
    }
  }
);

// Async thunk for thirfparty interviewer
export const loginTPUser = createAsyncThunk(
  "auth/loginTPUser",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const response = await dishaApi.post(
        "/TP-user-Login",
        `username=${encodeURIComponent(email)}&password=${encodeURIComponent(
          password
        )}`,
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      );
      const data = response.data;

      localStorage.setItem("accessToken", data.access_token || "");
      localStorage.setItem("name", data.name || "");
      
      // Store in both storage types for legacy compatibility and cross-tab support
      window.sessionStorage.setItem("role", data.role);
      window.localStorage.setItem("role", data.role);
      window.sessionStorage.setItem("name", data.name);
      window.localStorage.setItem("name", data.name);
      window.sessionStorage.setItem("status", data.status);
      window.localStorage.setItem("status", data.status);
      window.sessionStorage.setItem("orgUserId", data.panelist_id || "");
      window.localStorage.setItem("orgUserId", data.panelist_id || "");
      return {
        name: data.name,
        role: data.role,
        email: data.email,
        panelistId: data.panelist_id,
        accessToken: data.access_token,
        status: data.status,
      };
    } catch (error) {
      console.error("TP Login Error:", error);
      Toast.error(
        error.response?.data?.message || "Login failed. Please try again."
      );
      return rejectWithValue(error.response?.data?.message || "Login failed");
    }
  }
);

// helper thunk to check activation_status before login TP_interviewer---
export const getAllTPInterviewers = createAsyncThunk(
  "auth/getAllTPInterviewers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await dishaApi.get("/get-all-interviewer");
      return response.data.active_users || [];
    } catch (error) {
      console.error("Error fetching TP Interviewers:", error);
      return rejectWithValue("Failed to fetch interviewer list");
    }
  }
);

// Async thunk for Admin login
export const loginAdmin = createAsyncThunk(
  "auth/loginAdmin",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const response = await dishaApi.post(
        "/admin-user-Login",
        `username=${encodeURIComponent(email)}&password=${encodeURIComponent(
          password
        )}`,
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      );
      const data = response.data;
      console.log("user login", data);

     // Store in localStorage for persistence (shared across tabs/windows)
      localStorage.setItem("accessToken", data.access_token);
      localStorage.setItem("name", data.name);
      localStorage.setItem("admin_id", data.admin_id || "");
      localStorage.setItem("organization_id", data.organization_id || "");
      
      // Store in both storage types for legacy compatibility and cross-tab support
      window.sessionStorage.setItem("role", data.role);
      window.localStorage.setItem("role", data.role);
      window.sessionStorage.setItem("name", data.name);
      window.localStorage.setItem("name", data.name);
      window.sessionStorage.setItem("status", data.status);
      window.localStorage.setItem("status", data.status);
      return {
        name: data.name,
        role: data.role,
        user_id: data.user_id || null,
        organizationId: data.organization_id || null,
        accessToken: data.access_token,
        status: data.status,
      };
    } catch (error) {
      console.error("Error logging in:", error);
      Toast.error(
        error.response?.data?.message || "Login failed. Please try again."
      );
      return rejectWithValue(error.response?.data?.message || "Login failed");
    }
  }
);

// Async thunk for OrgAdmin/Interviewer login
export const loginOrgUser = createAsyncThunk(
  "auth/loginOrgUser",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const response = await dishaApi.post(
        "/org-user-Login",
        `username=${encodeURIComponent(email)}&password=${encodeURIComponent(
          password
        )}`,
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      );
      const data = response.data;
      console.log("user login", data);

     // Store in localStorage for persistence (shared across tabs/windows)
      localStorage.setItem("accessToken", data.access_token || "");
      localStorage.setItem("name", data.name || "");
      localStorage.setItem("organization_id", data.organization_id || "");
      
      // Store in both storage types for legacy compatibility and cross-tab support
      window.sessionStorage.setItem("role", data.role);
      window.localStorage.setItem("role", data.role);
      window.sessionStorage.setItem("name", data.name);
      window.localStorage.setItem("name", data.name);
      window.sessionStorage.setItem("organizationId", data.organization_id || "");
      window.localStorage.setItem("organizationId", data.organization_id || "");
      window.sessionStorage.setItem("orgUserId", data.panelist_id || "");
      window.localStorage.setItem("orgUserId", data.panelist_id || "");
      window.sessionStorage.setItem("status", data.status);
      window.localStorage.setItem("status", data.status);
      return {
        name: data.name,
        role: data.role,
        organizationId: data.organization_id || null,
        orgUserId: data.panelist_id || null,
        accessToken: data.access_token || "",
        status: data.status,
      };
    } catch (error) {
      console.error("Error logging in:", error);
      Toast.error(
        error.response?.data?.message || "Login failed. Please try again."
      );
      return rejectWithValue(error.response?.data?.message || "Login failed");
    }
  }
);

// Reset password for any user type

export const resetPassword = createAsyncThunk(
  "auth/resetPassword",

  async (
    { email, otp, newPassword, confirmPassword, role },
    { rejectWithValue }
  ) => {
    try {
      let url = "";

      if (role === "Admin") {
        url = `/admin-user-Password-Reset/?new_password=${encodeURIComponent(
          newPassword
        )}&confirm_password=${encodeURIComponent(confirmPassword)}`;
      } else if (
        role === "OrgAdmin" ||
        role === "Interviewer" ||
        role === "HR"
      ) {
        url = `/org-user-Password-Reset/?new_password=${encodeURIComponent(
          newPassword
        )}&confirm_password=${encodeURIComponent(confirmPassword)}`;
      } else {
        return rejectWithValue("Invalid user role for password reset");
      }

      const response = await dishaApi.post(url, { email, otp });

      return response.data;
    } catch (error) {
      Toast.error(error.response?.data?.detail || "Failed to reset password");

      return rejectWithValue(
        error.response?.data?.detail ||
          "An error occurred while resetting password"
      );
    }
  }
);

// Request OTP for Admin password reset
export const requestAdminOtp = createAsyncThunk(
  "auth/requestAdminOtp",
  async (email, { rejectWithValue }) => {
    try {
      const response = await dishaApi.post(
        `/admin-user-Forget-Password-Email/?email=${encodeURIComponent(email)}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail || "Failed to send OTP to admin"
      );
    }
  }
);

// Request OTP for OrgAdmin/Interviewer password reset
export const requestOrgUserOtp = createAsyncThunk(
  "auth/requestOrgUserOtp",
  async (email, { rejectWithValue }) => {
    try {
      const response = await dishaApi.post(
        `/org-user-Forget-Password-Email/?email=${encodeURIComponent(email)}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail ||
          "Failed to send OTP to organization user"
      );
    }
  }
);

// Candidate OTP request
export const requestCandidateOtp = createAsyncThunk(
  "auth/requestCandidateOtp",
  async (email, { rejectWithValue }) => {
    try {
      const response = await dishaApi.post(
        `/send-otp-to-candidate?email=${encodeURIComponent(email)}`
      );
      const data = response.data;
      return {
        role: "Candidate",
        organizationId: data.organization_id,
        candidateId: data.candidate_id,
        accessToken: data.access_token || "token",
      };
    } catch (error) {
      Toast.error(error.response?.data?.message || "Failed to send OTP");
      return rejectWithValue(
        error.response?.data?.message || "OTP request failed"
      );
    }
  }
);

// Request OTP for TP_Interviewer (uses generic forget password endpoint)
export const requestTPOtp = createAsyncThunk(
  "auth/requestTPOtp",
  async (email, { rejectWithValue }) => {
    try {
      const response = await dishaApi.post(
        `/Forget-Password/?email=${encodeURIComponent(email)}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to send OTP to interviewer"
      );
    }
  }
);

// Update password for TP_Interviewer
export const updateTPPassword = createAsyncThunk(
  "auth/updateTPPassword",
  async ({ email, otp, newPassword, confirmPassword }, { rejectWithValue }) => {
    try {
      const response = await dishaApi.put(
        `/update_interviewer_password?new_password=${encodeURIComponent(
          newPassword
        )}&confirm_password=${encodeURIComponent(confirmPassword)}`,
        { email, otp },
        { headers: { "Content-Type": "application/json" } }
      );
      return response.data;
    } catch (error) {
      Toast.error(error.response?.data?.message || "Failed to update password");
      return rejectWithValue(
        error.response?.data?.message || "Password update failed"
      );
    }
  }
);

const initialState = {
  isAuthenticated: false,
  user: null, // { name, role, adminId, organizationId, orgUserId, accessToken }
  loading: false,
  error: null,
  userType: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.loading = false;
      state.error = null;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.user = null;
      state.loading = false;
      state.error = null;
      state.userType = null;
      localStorage.clear();
      sessionStorage.clear();
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    clearUserType(state) {
      state.userType = null;
    },
    setResetPasswordData(state, action) {
      state.resetPasswordData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkUserType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(checkUserType.fulfilled, (state, action) => {
        state.loading = false;
        state.userType = action.payload.role;
      })
      .addCase(checkUserType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(loginAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginAdmin.fulfilled, (state, action) => {
        state.isAuthenticated = true;
        state.user = action.payload;
        state.loading = false;
      })
      .addCase(loginAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(loginOrgUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginOrgUser.fulfilled, (state, action) => {
        state.isAuthenticated = true;
        state.user = action.payload;
        state.loading = false;
      })
      .addCase(loginOrgUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(requestCandidateOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(requestCandidateOtp.fulfilled, (state, action) => {
        state.isAuthenticated = true; // Partial auth until OTP verified
        state.user = action.payload;
        state.loading = false;
      })
      .addCase(requestCandidateOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
        // You can add additional state updates if needed
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(REHYDRATE, (state, action) => {
        // If we have auth data in the persisted state, we check that the token still exists in localStorage
        if (
          action.payload &&
          action.payload.auth &&
          action.payload.auth.isAuthenticated
        ) {
          const token = localStorage.getItem("accessToken");
          // If token is removed manually from localStorage, ensure we're not authenticated
          if (!token) {
            state.isAuthenticated = false;
            state.user = null;
          }
        }
      })
      .addCase(loginTPUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginTPUser.fulfilled, (state, action) => {
        state.isAuthenticated = true;
        state.user = action.payload;
        state.loading = false;
      })
      .addCase(loginTPUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  loginSuccess,
  logout,
  setLoading,
  setError,
  clearUserType,
  setResetPasswordData,
} = authSlice.actions;
export default authSlice.reducer;
